import { render, staticRenderFns } from "./modal-popup.vue?vue&type=template&id=3887f55e&"
import script from "./modal-popup.vue?vue&type=script&lang=js&"
export * from "./modal-popup.vue?vue&type=script&lang=js&"
import style0 from "./modal-popup.vue?vue&type=style&index=0&id=3887f55e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports